module.exports = __webpack_public_path__ + "img/digitalTransformation.1176932c.png";